import { AxiosError } from "axios";

import { QueryClient } from "react-query";

function isNetworkError(error: unknown): boolean {
  if (error instanceof AxiosError) {
    // Network errors and unparseable responses
    if (
      error.code === "ERR_NETWORK" ||
      error.code === "ECONNABORTED" ||
      error.code === "ETIMEDOUT" ||
      error.code === "ERR_BAD_RESPONSE" ||
      error.message === "Network Error" ||
      !error.response
    ) {
      return true;
    }

    // Server errors that should be retried
    if (error.response?.status && error.response.status >= 500) {
      return true;
    }

    // Rate limiting
    if (error.response?.status === 429) {
      return true;
    }
  }

  return false;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          // Don't retry more than 3 times
          if (failureCount >= 3) {
            return false;
          }

          // Only retry on network errors and server errors
          return isNetworkError(error);
        },
        retryDelay: (attemptIndex) => {
          // Exponential backoff: 1s, 2s, 4s
          return Math.min(1000 * 2 ** attemptIndex, 30000);
        },
      },
      mutations: {
        retry: false, // No retries for mutations
      },
    },
  });
}
